import {View, Text} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {ReportTopQuestionScale} from './ReportTopQuestionScale';
import {sharedStyles} from './styles/shared-styles';
import {greenColors, orangeColors} from '../../../../../layouts/theme/designSystem';
import {CultureMatchItem} from '../../../../applicant/dashboard/types/ApplicantMatchesTypes';
import {questionCardScalesStyles} from '../../../recruiting/applicant-pdf-export/components/styles/question-card-scales-styles';

interface Props {
  t: TFunction;
  topQuestions: CultureMatchItem[];
  currentLanguage: 'de' | 'en';
  applicantName: string;
}

export const ReportTopQuestionsCardScales = ({t, topQuestions, currentLanguage, applicantName}: Props) => {
  const renderLegend = () => {
    return (
      <View style={{display: 'flex', flexDirection: 'row'}} wrap={false}>
        <View style={questionCardScalesStyles.legendItem}>
          <View style={[questionCardScalesStyles.legendBar, {backgroundColor: orangeColors[100]}]} />
          <Text style={questionCardScalesStyles.legendText}>{t('applicantPdfExport.us')}</Text>
        </View>
        <View style={questionCardScalesStyles.legendItem}>
          <View style={[questionCardScalesStyles.legendBar, {backgroundColor: greenColors[100]}]} />
          <Text style={questionCardScalesStyles.legendText}>{applicantName}</Text>
        </View>
      </View>
    );
  };

  return (
    <>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <View style={{flexGrow: 3, maxWidth: '235px'}}>{renderLegend()}</View>
        <View style={{flexGrow: 1, alignItems: 'center', paddingLeft: 8}}>
          <Text style={{...sharedStyles.h4, fontWeight: 'bold'}}>
            {t('screeningModule.report.topQuestions.overAll')}
          </Text>
        </View>
        <View style={{flexGrow: 6, maxWidth: '235px'}}>
          <Text style={{...sharedStyles.h4, fontWeight: 'bold'}}>
            {t('screeningModule.report.topQuestions.descriptionScalles')}
          </Text>
        </View>
      </View>

      {topQuestions.map((question, index) => (
        <ReportTopQuestionScale
          key={`${question.resourceId + index}`}
          currentLanguage={currentLanguage}
          scaleItem={question}
          isLast={index === topQuestions.length - 1}
        />
      ))}
    </>
  );
};
